export default {"src":"/_next/static/media/cherries.9fd2f989.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};